export enum ThreeHeadedDragonCardPosition {
    GoldenDragonCard = 0,
    BlackDragonCard = 1,
    RedDragonCard = 2,
    TigerCard = 3
}

export enum ThreeHeadedDragonOutcome {
    DragonWin = 0,
    TigerWin = 1,
    Tie = 2
}

export enum ThreeHeadedDragonSidePosition {
    Dragon = 'dragon',
    Tiger = 'tiger'
}

export interface ThreeHeadedDragonHandValues {
    tigerHandValue: number;
    goldenDragonHandValue: number;
    blackDragonHandValue: number;
    redDragonHandValue: number;
}
